import { doctor, pharmacy } from '@/configs/translates.config';

export default {
	save: {
		en: 'Save',
		ar: 'حفظ'
	},
	add: {
		en: 'Add',
		ar: 'إضافة'
	},
	edit: {
		en: 'Edit',
		ar: 'تعديل'
	},
	delete: {
		en: 'Delete',
		ar: 'حذف'
	},
	done: {
		en: 'Done',
		ar: 'موافق'
	},
	close: {
		en: 'Close',
		ar: 'إغلاق'
	},
	send: {
		en: 'Send',
		ar: 'إرسال'
	},
	cancel: {
		en: 'Cancel',
		ar: 'إلغاء'
	},
	update: {
		en: 'Update',
		ar: 'تحديث'
	},
	ok: {
		en: 'OK',
		ar: 'موافق'
	},
	filters: {
		en: 'Filters',
		ar: 'الفلاتر'
	},
	inputs: {
		en: {
			username: 'Username',
			password: 'Password',
			date: 'Date',
			region: 'Region',
			'customer-name': 'Customer name',
			persons: 'Persons',
			name: 'Name',
			samples: 'Samples',
			sample: 'Sample',
			amount: 'Amount',
			'unavailable-products': 'Unavailable Products',
			competitors: 'Competitors',
			competitor: 'Competitor',
			'core-message': 'Core message',
			duration: 'Duration',
			'duration-minutes': 'Duration (in minutes)',
			minutes: 'minutes',
			'other-materials': 'Other Materials',
			'visit-notes': 'Visit notes',
			objection: 'Objection',
			'next-call': 'Next Call',
			notes: 'Notes',
			'center-notes': 'Center notes',
			report: 'Report',
			specialty: 'Specialty',
			workload: 'Workload',
			address: 'Address',
			'contact-type': 'Contact Type',
			contact: 'Contact',
			reason: 'Reason',
			'product-form': 'Product form',
			'product-name': 'Product name',
			'pharmaceutical-form': 'Pharmaceutical form',
			dose: 'Dose',
			'pieces-count': 'Pieces count',
			material: 'Material',
			type: 'Type',
			'days-count': 'Days count',
			'start-date': 'Start date',
			'pricing-types': 'Pricing types',
			price: 'Price',
			discount: 'Discount',
			free: 'Free',
			'payment-type': 'Payment type',
			'paid-amount': 'Paid amount',
			weekend: 'Weekend',
			'work-hours-from': 'Work hours from',
			'work-hours-to': 'Work hours to',
			'best-time-to-visit': 'Best time to visit',
			'resident-doctors': 'Resident doctors',
			'doctor-hobbies': 'Doctor hobbies',
			'personal-note': 'Personal note',
			'pharmacy-info': 'Pharmacy info',
			loyalty: 'Loyalty',
			religion: 'Religion',
			personality: 'Personality',
			birthdate: 'Birthdate',
			quantity: 'Quantity',
			'nearby-pharmacy-1': 'Nearby pharmacy 1',
			'nearby-pharmacy-2': 'Nearby pharmacy 2',
			'works-in-centers': 'Works in centers',
			'pharmacist-info': 'Pharmacist info',
		},
		ar: {
			username: 'اسم المستخدم',
			password: 'كلمة المرور',
			date: 'التاريخ',
			region: 'المنطقة',
			'customer-name': 'اسم العميل',
			persons: 'الأشخاص',
			name: 'الاسم',
			samples: 'العينات',
			sample: 'عينة',
			amount: 'الكمية',
			'unavailable-products': 'المنتجات غير متوفرة',
			competitors: 'المنافسون',
			competitor: 'منافس',
			'core-message': 'الرسالة الأساسية',
			duration: 'المدة',
			'duration-minutes': 'المدة (بالدقائق)',
			minutes: 'دقائق',
			'other-materials': 'مواد أخرى',
			'visit-notes': 'ملاحظات الزيارة',
			objection: 'اعتراض',
			'next-call': 'التواصل القادم',
			notes: 'الملاحظات',
			'center-notes': 'ملاحظات المركز',
			report: 'التقرير',
			specialty: 'التخصص',
			workload: 'الفئة',
			address: 'العنوان',
			'contact-type': 'التوع',
			contact: 'تواصل',
			reason: 'السبب',
			'product-form': 'شكل المنتج',
			'product-name': 'اسم المنتح',
			'pharmaceutical-form': 'الشكل الصيدلي',
			dose: 'الجرعة',
			'pieces-count': 'عدد القطع',
			material: 'المادة',
			type: 'النوع',
			'days-count': 'عدد الأيام',
			'start-date': 'تاريخ البدء',
			'pricing-types': 'نمط التسعير',
			price: 'السعر',
			discount: 'الحسم',
			free: 'مجاني',
			'payment-type': 'طريقة الدفع',
			'paid-amount': 'المبلغ المدفوع',
			weekend: 'عطلة نهاية الأسبوع',
			'work-hours-from': 'ساعات العمل من',
			'work-hours-to': 'ساعات العمل إلى',
			'best-time-to-visit': 'أفضل وقت للزيارة',
			'resident-doctors': 'الأطباء المقيمين',
			'doctor-hobbies': 'هوايات الأطباء',
			'personal-note': 'ملاحظة شخصية',
			'pharmacy-info': 'معلومات الصيدلية',
			loyalty: 'الولاء',
			religion: 'الديانة',
			personality: 'الشخصية',
			birthdate: 'عيد الميلاد',
			quantity: 'الكمية',
			'nearby-pharmacy-1': 'أقرب صيدلية(1)',
			'nearby-pharmacy-2': 'أقرب صيدلية(2)',
			'works-in-centers': 'يعمل في مراكز',
			'pharmacist-info': 'معلومات عن الزبون'
		}
	},
	headers: {
		en: {
			customer: 'customer'
		},
		ar: {
			customer: 'العميل'
		}
	},
	'entities-type': {
		en: {
			doctors: doctor.en.plural,
			pharmacies: pharmacy.en.plural,
			centers: 'Centers'	
		},
		ar: {
			doctors: doctor.ar.plural,
			pharmacies: pharmacy.ar.plural,
			centers: 'المراكز'
		}
	},
	'payment-method': {
		en: {
			cash: 'Cash',
			credit: 'Credit',
			debit: 'Debit',
		},
		ar: {
			cash: 'نقدي',
			credit: 'بطاقة',
			debit: 'دَين',
		}
	},
	components: {
		en: {
			today: 'Today',
			logout: 'Logout'
		},
		ar: {
			today: 'اليوم',
			logout: 'تسجيل خروج'
		}
	},

	messages: {
		en: {
			'are-you-sure-you-want-to-delete-$': "Are you sure you want to <span class='red--text'>DELETE</span> {text}?",
			'one-address-for-pharmacies-and-centers': 'Sorry, but one address is allowed for pharmacies and centers',
			'matched-entities': 'Matched entities',
			'confirm-delete': 'Confirm delete'
		},
		ar: {
			'are-you-sure-you-want-to-delete-$': "هل أنت متأكد من <span class='red--text'>حذف</span> {text}؟",
			'one-address-for-pharmacies-and-centers': 'عذراً ، لكن يسمح بعنوان واحد للصيدليات والمراكز',
			'matched-entities': 'جهات مطابقة',
			'confirm-delete': 'تأكيد الحذف',
		}
	},

	'validation-messages': {
		en: {
			required: 'This field is required',
			number: 'This number should be non-negative.',
			url: 'Invalid URL.',
			val: 'Invalid date. Date format is \'yyyy-mm-dd\'.',
			password: 'password should be 4 characters at least',
			email: 'Invalid e-mail.',
			'one-address-at-least': 'Must add one address at least',
		},
		ar: {
			required: 'هذا الحقل مطلوب',
			number: 'يجب أن يكون رقمًا غير سالبًا.',
			url: 'URL غير صالح.',
			val: 'تاريخ غير صالح. تنسيق التاريخ هو \'yyyy-mm-dd\'.',
			password: 'يجب أن تكون كلمة المرور 4 أحرف على الأقل.',
			email: 'بريد إلكتروني غير صالح.',
			'one-address-at-least': 'يجب إضافة عنوان واحد على الأقل',
		}
	}
}